import FileUpload from "components/FileUpload";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import {
  fetchExhibitCourtDecisionType,
  fetchExhibitProsecutorDecisionType,
} from "services/basedataServices";
import { editExhibit2 } from "services/incidentService";
import {
  Exhibit,
  ExibitCourtDecisionType,
  ExibitProsecutionDecisionType,
  Roles,
} from "types";
import { errorHandler, hasRole } from "utils/helper";

type Props = {
  exhibit: Exhibit | undefined;
  isOpen: boolean;
  onClose: (refetch?: boolean) => void;
};

const ExhibitDetail: FC<Props> = ({ exhibit, isOpen, onClose }) => {
  const { showTooltip } = useTooltip();
  const { loginData } = useAuth();
  // const [loading, setLoading] = useState(false);

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose();
    }
  };
  const [formState, setFormState] = useState<any>({
    prosecution_decision_type: "",
    prosecution_decision_description: "",
    // prosecution_files: null,
    // prosecutor_decision_date: Date,
    court_decision_type: "",
    court_decision_description: "",
    court_decision_file: null,
    // court_decision_date: Date,
  });

  const [baseData, setBaseData] = useState<{
    exhibitProsecutorDecsionType: ExibitProsecutionDecisionType[];
    exhibitCourtDecsionType: ExibitCourtDecisionType[];
  }>({
    exhibitProsecutorDecsionType: [],
    exhibitCourtDecsionType: [],
  });

  useEffect(() => {
    fetchExhibitProsecutorDecisionType().then((data) =>
      setBaseData((prev) => ({
        ...prev,
        exhibitProsecutorDecsionType:
          data as unknown as ExibitProsecutionDecisionType[],
      }))
    );
    fetchExhibitCourtDecisionType().then((data) =>
      setBaseData((prev) => ({
        ...prev,
        exhibitCourtDecsionType: data as unknown as ExibitCourtDecisionType[],
      }))
    );
  }, []);

  const [viewType, setViewType] = useState("detail");

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isProsecutor = hasRole(loginData?.roles, [Roles.prosecutor]);

  const validateForm = () => {
    // if (!formState.tool_type) return "Tool Type is Required.";
    // else if (!formState.collected_by) return "Collected By is Required.";
    // else if (!formState.date_collected) return "Date Collected is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    // setLoading(true);
    const payload = {
      // ...formState,
      uu_id: exhibit?.uu_id,
      prosecution_decision_type: exhibit?.prosecution_decision_type
        ? undefined
        : formState?.prosecution_decision_type,
      prosecution_decision_description: exhibit?.prosecution_decision_type
        ? undefined
        : formState?.prosecution_decision_description,
      prosecution_decision_file: exhibit?.prosecution_decision_type
        ? undefined
        : formState?.prosecution_decision_file,
      prosecutor_decision_date: exhibit?.prosecution_decision_type
        ? undefined
        : formState?.prosecutor_decision_date,

      court_decision_type: exhibit?.court_decision_type
        ? undefined
        : formState?.court_decision_type,
      court_decision_description: exhibit?.court_decision_type
        ? undefined
        : formState?.court_decision_description,
      court_decision_file: exhibit?.court_decision_type
        ? undefined
        : formState?.court_decision_file,
      court_decision_date: exhibit?.court_decision_type
        ? undefined
        : formState?.court_decision_date,
    };

    editExhibit2(payload)
      .then(() => {
        showTooltip("Successfully Updated!", "success");
        // setFormState(defaultEvidence);
        onClose(true);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandler(error),
          "error"
        );
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div
        className={`relative w-full bg-white p-8 shadow-lg rounded-lg  flex flex-col max-w-2xl`}
      >
        <div
          className={`overflow-y-scroll overflow-x-hidden min-w-2xl border-r-2 pr-6 mb-4`}
        >
          {/* Header */}
          <div className="flex items-start justify-between mb-6">
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-[#AA232F] mb-1">
                Exhibit Details
              </h2>
              <p className="text-gray-500 text-sm">
                All information about this evidence file.
              </p>
            </div>
            <button
              className="text-gray-400 hover:text-[#AA232F] text-2xl font-bold transition"
              onClick={() => onClose(false)}
              title="Close"
              type="button"
            >
              &times;
            </button>
          </div>
          {viewType === "detail" && (
            <div className="space-y-3">
              <DetailItem
                label="Incident Registration Number"
                value={exhibit?.Incident_Registration_number}
              />
              <DetailItem label="CR Number" value={exhibit?.CR_number} />
              <DetailItem label="Tool Type" value={exhibit?.tool_type} />
              {/* <DetailItem label="Description" value={exhibit?.description} /> */}
              <DetailItem label="Collected By" value={exhibit?.collected_by} />
              <DetailItem
                label="Unique Identification Code"
                value={exhibit?.unique_identification_code}
              />
              <DetailItem
                label="Reference Number"
                value={exhibit?.reference_number}
              />
              <DetailItem
                label="Serial Number"
                value={exhibit?.serial_number}
              />
              <DetailItem
                label="Location Region"
                value={exhibit?.location_region}
              />
              <DetailItem
                label="Location Zone"
                value={exhibit?.location_zone}
              />
              <DetailItem
                label="Location Woreda"
                value={exhibit?.location_woreda}
              />
              <DetailItem
                label="Location House Number"
                value={exhibit?.location_housenumber}
              />
              <DetailItem
                label="Location Site"
                value={exhibit?.location_site}
              />
              <DetailItem
                label="Person With Whom"
                value={exhibit?.person_with_whom}
              />
              <DetailItem label="Owner" value={exhibit?.owner} />
              <DetailItem
                label="Quantity Written"
                value={exhibit?.quantity_written}
              />
              <DetailItem
                label="Exhibit Condition"
                value={exhibit?.exibit_condition}
              />
              {/* <DetailItem
            label="Exhibit Condition When Submitted"
            value={exhibit?.prosecution_decision_type}
          /> */}

              {/* Person Protect Fields */}
              <SectionTitle label="Person Protect Information" />
              <DetailItem
                label="Full Name"
                value={exhibit?.person_protect_fullname}
              />
              <DetailItem
                label="Region"
                value={exhibit?.person_protect_region}
              />
              <DetailItem label="Zone" value={exhibit?.person_protect_zone} />
              <DetailItem
                label="Woreda"
                value={exhibit?.person_protect_woreda}
              />
              <DetailItem
                label="House Number"
                value={exhibit?.person_protect_housenumber}
              />
              <DetailItem
                label="Phone Number"
                value={exhibit?.person_protect_phonenumber}
              />
              <DetailItem label="Site" value={exhibit?.person_protect_site} />

              {/* Government Protect Fields */}
              <SectionTitle label="Government Protect Information" />
              <DetailItem
                label="Name"
                value={exhibit?.government_protect_name}
              />
              <DetailItem
                label="Region"
                value={exhibit?.government_protect_region}
              />
              <DetailItem
                label="Zone"
                value={exhibit?.government_protect_zone}
              />
              <DetailItem
                label="Woreda"
                value={exhibit?.government_protect_woreda}
              />
              <DetailItem
                label="House Number"
                value={exhibit?.government_protect_housenumber}
              />
              <DetailItem
                label="Phone Number"
                value={exhibit?.government_protect_phonenumber}
              />
              <DetailItem
                label="Site"
                value={exhibit?.government_protect_site}
              />
              <SectionTitle label="Sample Collection Information" />
              <DetailItem
                label="Sample Collected"
                value={
                  exhibit?.is_sample_collected === true
                    ? "Yes"
                    : exhibit?.is_sample_collected === false
                    ? "No"
                    : ""
                }
              />
              {exhibit?.is_sample_collected && (
                <>
                  <DetailItem
                    label="Sample Collected By"
                    value={exhibit?.sample_collected_by}
                  />
                  <DetailItem
                    label="Sample Collection Date"
                    value={
                      exhibit?.sample_collection_date
                        ? new Date(
                            exhibit.sample_collection_date
                          ).toLocaleDateString()
                        : ""
                    }
                  />
                  <DetailItem
                    label="Sample Amount"
                    value={exhibit?.sample_amount}
                  />
                  <DetailItem
                    label="Sample Location"
                    value={exhibit?.sample_location}
                  />
                  <DetailItem
                    label="Analysis Result"
                    value={exhibit?.analysis_result}
                  />
                  <DetailItem
                    label="Sample Returned"
                    value={
                      exhibit?.is_sample_returned === true
                        ? "Yes"
                        : exhibit?.is_sample_returned === false
                        ? "No"
                        : ""
                    }
                  />
                  <DetailItem
                    label="Sample Return Date"
                    value={
                      exhibit?.sample_return_date
                        ? new Date(
                            exhibit.sample_return_date
                          ).toLocaleDateString()
                        : ""
                    }
                  />
                </>
              )}
            </div>
          )}
        </div>

        {viewType === "detail" && exhibit?.description && (
          <div className="bg-[#F8F8F8] p-4 rounded-xl mt-8">
            <p className="font-semibold text-[#AA232F] mb-1">Description</p>
            <p className="text-gray-700">{exhibit?.description}</p>
          </div>
        )}
        {viewType === "prosecutor" && (
          <div className="grid grid-cols-1 gap-4">
            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Decision Type
              </label>
              <select
                className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                name="prosecution_decision_type"
                value={
                  typeof formState?.prosecution_decision_type === "string"
                    ? formState.prosecution_decision_type
                    : formState?.prosecution_decision_type?.name ?? ""
                }
                onChange={handleChange}
              >
                <option value={""}>Select Exhibit Condition</option>
                {baseData?.exhibitProsecutorDecsionType.map((type, index) => (
                  <option key={index} value={type?.name}>
                    {type?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Decision Date
              </label>
              <input
                type="date"
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="prosecutor_decision_date"
                value={
                  formState?.prosecutor_decision_date
                    ? new Date(formState.prosecutor_decision_date)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <FileUpload
                label="Attachment Files"
                fileTypes="*"
                info="Upload PDF Files"
                required={true}
                onChange={(file) => {
                  setFormState({
                    ...formState,
                    prosecution_decision_file: file,
                  });
                }}
              />
            </div>
          </div>
        )}

        {viewType === "court" && (
          <div className="grid grid-cols-1 gap-4">
            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Decision Type
              </label>
              <select
                className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                name="court_decision_type"
                value={
                  typeof formState?.court_decision_type === "string"
                    ? formState.court_decision_type
                    : formState?.court_decision_type?.name ?? ""
                }
                onChange={handleChange}
              >
                <option value={""}>Select Exhibit Condition</option>
                {baseData?.exhibitProsecutorDecsionType.map((type, index) => (
                  <option key={index} value={type?.name}>
                    {type?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Decision Date
              </label>
              <input
                type="date"
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="court_decision_date"
                value={
                  formState?.court_decision_date
                    ? new Date(formState.court_decision_date)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <FileUpload
                label="Attachment Files"
                fileTypes="*"
                info="Upload PDF Files"
                required={true}
                onChange={(file) => {
                  setFormState({
                    ...formState,
                    court_decision_file: file,
                  });
                }}
              />
            </div>
          </div>
        )}

        <div className="mt-2 text-right">
          {!exhibit?.prosecution_decision_type && isProsecutor && (
            <button
              type="button"
              className={`border border-[#212121] bg-[#212121] px-[10px] py-2 
                                text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]
                                   ""}`}
              onClick={(e) => {
                viewType === "prosecutor"
                  ? handleSubmit(e)
                  : setViewType("prosecutor");
              }}
            >
              Prosecutor Decision
            </button>
          )}
          {exhibit?.prosecution_decision_type &&
            !exhibit?.court_decision_type && (
              <button
                type="button"
                className={`border border-[#212121] bg-[#212121] px-[76px] py-2 
                                text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]
                                   ""}`}
                onClick={(e) => {
                  viewType === "court" ? handleSubmit(e) : setViewType("court");
                }}
              >
                Court Decision
              </button>
            )}
        </div>
      </div>
    </div>
  );
};

// Helper for section titles
const SectionTitle = ({ label }: { label: string }) => (
  <div className="pt-4 pb-1 text-[#AA232F] font-semibold text-base">
    {label}
  </div>
);

// Helper for detail rows
const DetailItem = ({
  label,
  value,
}: {
  label: string;
  value: string | number | undefined | null;
}) =>
  value ? (
    <div className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3">
      <span className="font-medium text-[#0A1D39] w-56">{label}:</span>
      <span className="text-[#212121]">{value}</span>
    </div>
  ) : null;

export default ExhibitDetail;
